import { LOCATION_PERMISSION_STATE } from '@/constants/types';
import { configDistance } from '@/constants/storeDistanceConfig';
// import { getDistance } from 'geolib';
import { generateHref } from '@/url/storeLocator';

const getDistance = (from, to) => {
  const R = 6371e3; // metres
  const phi1 = from.latitude * (Math.PI / 180); // φ in radians
  const phi2 = to.latitude * (Math.PI / 180); // φ in radians
  const deltaPhi = (to.latitude - from.latitude) * (Math.PI / 180); // difference in latitude in radians
  const deltaLambda = (to.longitude - from.longitude) * (Math.PI / 180); // difference in longitude in radians
  // a = sin²(Δφ/2) + cos φ1 ⋅ cos φ2 ⋅ sin²(Δλ/2)
  const a =
    Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
    Math.cos(phi1) *
      Math.cos(phi2) *
      Math.sin(deltaLambda / 2) *
      Math.sin(deltaLambda / 2);
  // c = 2 ⋅ atan2( √a, √(1−a) )
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return distance > 0.0 ? distance : 0.001; // returns distance in metres
};

export function addDistanceKey(distance) {
  const config = configDistance;
  const result = config.find(
    (item) =>
      (item.min === undefined || distance >= item.min) &&
      (item.max === undefined || distance <= item.max),
  );

  return result ? result.key : null;
  // Return null or a default key if no match is found
}

export function calculateDistance(
  items,
  locPermissionState,
  userLocation = null,
) {
  const { GRANTED } = LOCATION_PERMISSION_STATE;

  if (
    userLocation !== null &&
    userLocation !== undefined &&
    locPermissionState === GRANTED
  ) {
    if (items?.length > 0) {
      const updatedDataWithDistance = [];
      const tempItems = [...items];
      tempItems?.forEach((element) => {
        // after getting location add calculated distance to the array
        if (userLocation !== null && userLocation !== undefined) {
          const distance = getDistance(
            {
              latitude: userLocation.latitude,
              longitude: userLocation.longitude,
            },
            {
              latitude: parseFloat(element.latitude),
              longitude: parseFloat(element.longitude),
            },
          );
          const distanceInKm = (distance / 1000).toFixed(2); // Convert meters to kilometers
          const hrefUrl = generateHref(
            `${element.latitude}, ${element.longitude}`,
            `${userLocation.latitude},${userLocation.longitude}`,
          ); // Create the href link for opening the map in new tab

          updatedDataWithDistance.push({
            ...element,
            distance: addDistanceKey(distanceInKm),
            distanceInM: distance,
            hrefUrl,
          });
        }
      });

      if (updatedDataWithDistance.length) {
        const sortedLocation = updatedDataWithDistance.sort(
          (a, b) => a.distanceInM - b.distanceInM,
        );
        return sortedLocation;
      }
    }
  } else if (items?.length > 0) {
    const updatedDataWithDistance = [];
    const tempItems = [...items];
    tempItems?.forEach((element) => {
      // Create the href link for opening the map in new tab
      const hrefUrl = generateHref(`${element.latitude}, ${element.longitude}`);

      updatedDataWithDistance.push({ ...element, hrefUrl });
    });
    if (updatedDataWithDistance.length) {
      return updatedDataWithDistance;
    }
  }
  // distance and href calculate
  return items;
}

export function calculateDistanceForSpecificItem(
  item,
  locPermissionState,
  userLocation = null,
) {
  const { GRANTED } = LOCATION_PERMISSION_STATE;
  if (
    userLocation !== null &&
    userLocation !== undefined &&
    locPermissionState === GRANTED
  ) {
    if (Object.keys(item)?.length > 0) {
      const distance = getDistance(
        {
          latitude: userLocation.latitude,
          longitude: userLocation.longitude,
        },
        {
          latitude: parseFloat(item.latitude),
          longitude: parseFloat(item.longitude),
        },
      );
      const distanceInKm = (distance / 1000).toFixed(2); // Convert meters to kilometers
      const hrefUrl = generateHref(
        `${item.latitude}, ${item.longitude}`,
        `${userLocation.latitude},${userLocation.longitude}`,
      ); // Create the href link for opening the map in new tab

      const updatedDataWithDistance = {
        ...item,
        distance: addDistanceKey(distanceInKm),
        hrefUrl,
      };
      return updatedDataWithDistance;
    }
  } else if (Object.keys(item)?.length > 0) {
    // Create the href link for opening the map in new tab
    const hrefUrl = generateHref(`${item.latitude}, ${item.longitude}`);
    const updatedDataWithDistance = {
      ...item,
      hrefUrl,
    };

    return updatedDataWithDistance;
  }
  // distance and href calculate
  return item;
}
